import React from "react";
import { GetStaticProps, GetStaticPropsResult, NextPage } from "next";
import { ParsedUrlQuery } from "querystring";

import { SeoPageProps } from "@libs";
import { fetchStartups } from "@api";
import { sortCategoriesCounter } from "@utils";
import { StartupsExplorer } from "@app-components";
import { getRegionsCounter, getSectorsCounter } from "@pages_shared/startups/explorer/get-startups-categories-counter";
import { getStartupsTopCategoriesTranslations } from "@pages_shared/startups/explorer/get-startups-top-categories-translations";
import messages from "@pages_messages/startups/explorer/messages";

import withHeader from "hocs/withHeader";
import Footer from "containers/Footer";

type StartupsStaticProps = {
	topSectors: [string, number][];
	topRegions: [string, number][];
};

const StartupsExplorerPage: NextPage<StartupsStaticProps & { query: ParsedUrlQuery }> = ({
	topSectors,
	topRegions,
	query,
}: StartupsStaticProps & { query: ParsedUrlQuery }) => {
	const { topRegionsWithCategory, topSectorsWithCategory } = getStartupsTopCategoriesTranslations({
		topSectors,
		topRegions,
	});
	const { page } = query;
	const pageNumber: number = Number.isInteger(Number(page)) ? Number(page) : 0;

	return (
		<>
			<StartupsExplorer
				initialPageNumber={pageNumber}
				topSectors={topSectorsWithCategory}
				topRegions={topRegionsWithCategory}
			/>
			<div className="relative bg-white">
				<Footer />
			</div>
		</>
	);
};

export const getStaticProps: GetStaticProps<SeoPageProps & StartupsStaticProps> = async (): Promise<
	GetStaticPropsResult<SeoPageProps & StartupsStaticProps>
> => {
	const { items } = await fetchStartups({
		page: 1,
		perPage: 9999999,
		orderDirection: "DESC",
	})();
	const sectorsCounter = getSectorsCounter({
		items,
	});
	const regionsCounter = getRegionsCounter({
		items,
	});

	return {
		props: {
			topSectors: sortCategoriesCounter(sectorsCounter),
			topRegions: sortCategoriesCounter(regionsCounter),
			meta: {
				title: String(messages.title.id),
				description: String(messages.description.id),
			},
		},
	};
};

export default withHeader(StartupsExplorerPage);
